import React from 'react';
import { FaFileDownload } from 'react-icons/fa';

const DownloadBrochure = () => {
  return (
    <div className="flex justify-center items-center py-4 w-full">
      <button className="flex items-center space-x-2 border border-gray-300 bg-white hover:shadow-lg px-[20px] py-[20px] rounded-lg duration-300 w-full">
        <FaFileDownload className="text-red-600 text-[32px] mr-4" />
        <span className="text-[#303030] font-semibold text-base">Download Brochure</span>
      </button>
    </div>
  );
};

export default DownloadBrochure;
